import { gql } from '@apollo/client';

export const CONFIRM_BILL_ATTACHMENT_UPLOAD = gql`
  mutation ConfirmBillAttachmentUpload(
    $billId: ID!
    $objectKey: String!
    $fileName: String!
    $fileSize: Long!
    $contentType: String!
    $confirmedFlow: Boolean!
  ) {
    confirmBillAttachmentUpload(
      billId: $billId
      objectKey: $objectKey
      fileName: $fileName
      fileSize: $fileSize
      contentType: $contentType
      confirmedFlow: $confirmedFlow
    ) {
      id
      billId
      fileName
      fileSize
      contentType
      uploaderId
      uploaderName
      createdAt
      canDelete
    }
  }
`;

export const DELETE_BILL_ATTACHMENT = gql`
  mutation DeleteBillAttachment($attachmentId: ID!) {
    deleteBillAttachment(attachmentId: $attachmentId)
  }
`;
